<template>
    <div
        v-if="isBannerVisible"
        class="fixed right-4 bottom-4 left-4 z-50 flex max-w-md flex-col items-center gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-lg md:right-auto md:left-8 md:flex-row"
    >
        <div class="flex flex-col">
            <div>
                <p class="pb-5 text-sm text-gray-800">
                    {{ t("tracking.cookie_consent.text") }}
                </p>
            </div>
            <div class="ml-auto flex gap-2">
                <SmuButton color="secondary" @click="decline">
                    {{ t("tracking.cookie_consent.decline") }}
                </SmuButton>
                <SmuButton @click="accept">
                    {{ t("tracking.cookie_consent.accept") }}
                </SmuButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useTrackingConsent from "@/composables/useTrackingConsent";

const { t } = useI18n();

const config = useRuntimeConfig();

// eslint-disable-next-line func-style
const isHotjarInjected = () => {
    return (
        // eslint-disable-next-line unicorn/prefer-global-this
        (typeof window !== "undefined" && Array.isArray(window._uxa)) ||
        // eslint-disable-next-line unicorn/prefer-global-this
        typeof window.hj === "function"
    );
};

const isBannerVisible = computed(() => {
    if (!config.public.hotjarTrackingActive) {
        return false;
    }

    // If the user has already accepted or declined tracking, do not show the banner
    // The revokeConsent function will reload the page and the banner will be shown again
    if (isHotjarInjected()) {
        return false;
    }

    if (!isUndecided.value && !isExpired.value) {
        return false;
    }

    return true;
});

const { accept, decline, isExpired, isUndecided } = useTrackingConsent();
</script>
